import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Suspense } from 'react';
import { appRoutes } from '../pages/routes';
import { useTemplateRuntime } from '../hooks/useTemplateRuntime';
import { PincodeGate } from '../components/store/PincodeGate';
import { VerifyGate } from '../components/store/VerifyGate';
import { SeoHead } from '../components/seo/SeoHead';

/**
 * Root router — live Indusviva store gates + lazy pages + SEO head.
 */
export default function App() {
  const location = useLocation();
  useTemplateRuntime(location.pathname);

  return (
    <>
      <SeoHead />
      <PincodeGate />
      <VerifyGate />
      <Suspense fallback={null}>
        <Routes>
          {appRoutes.map(({ path, Component }) => (
            <Route key={path} path={path} element={<Component />} />
          ))}
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Suspense>
    </>
  );
}
